import { gsap } from "gsap";

import ScrollMagic from 'scrollmagic';

export default class Anim8_showreel {


	constructor(scroll, sceneFactory, controller, domElem) {

		if( !domElem ) {
			console.error('DOM ELEMENT FOR SHOWREEL NOT FOUND');
			return;
		}

		this.animatedIn = false;
		this.animatedOut = false;
		this.useScrollTrigger = true;

		this.domElem = domElem;
		this.sceneElemName = this.domElem.getAttribute('data-anchor').toLowerCase();
        this.sceneDuration = this.domElem.getAttribute('data-duration');
        this.sceneOffset = this.domElem.getAttribute('data-offset');

		this.dimensions = domElem.getBoundingClientRect();
		this.domVideo = domElem.querySelectorAll('video');
        this.domVideoContainer = domElem.querySelectorAll('.cursor-interactive-video');

        if( !this.domVideoContainer || this.domVideoContainer.length < 0) {
			console.error('DOM VIDEO CONTAINER ELEM NOT FOUND');
			return;
		}

		if( !this.domVideo ||  this.domVideo.length < 0 ) {
			console.error('DOM VIDEO ELEM NOT FOUND');
			return;
		}

		this.initTimeline();

		if( ![undefined,null].includes(scroll) && ![undefined,null].includes(controller) ) {
			this.initScrollMagic(scroll, sceneFactory, controller);
		} else {
			this.defaultTween();
		}

		console.warn("[Anim8_Showreel.js] loaded");

		return this.timeline;
		
	}

	initTimeline() {

		this.timeline = gsap.timeline({
			delay: 0,
			defaults: {
				//ease: "power3",
				ease: "power1.inOut"
			},
			scrollTrigger: (this.useScrollTrigger === true ? this.scrollTriggerOptions() : false),
			onComplete: () => {
				console.log("Anim8_Showreel.js finished");
			},
		});
	}

	scrollTriggerOptions() {

		return {
			trigger: this.domElem,
			pin: false, // pin the trigger element while active
			start: 'top center', // when the top of the trigger hits the top of the viewport
			end: `+=${this.dimensions.height * .5}`,
			//toggleActions: "play none none reset",
			scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
			//markers: {startColor:"green", endColor:"red", fontSize:"12px"},
			onToggle: self => console.log(`${this.sceneElemName} active:`, self.isActive),
			onEnter: (({progress, direction, isActive}) =>{})
		}

	}

	initScrollMagic(scroll, sceneFactory, controller) {

		this.scrollMagicScene = new ScrollMagic.Scene({
			triggerElement: this.domElem,
			duration: this.sceneDuration,
			offset:  this.dimensions.height * .5,
			//offset: 0,
			triggerHook: 'onEnter'
		})
		.setTween(this.defaultTween())
		.addTo(controller)
		.setClassToggle( this.domElem, 'active');

		scroll.options.scenes.push(this.scrollMagicScene);

		this.scrollMagicScene.on('enter', (e) => {

			if( this.animatedIn === false ) {
				this.animatedIn = true;
			}

			//this.animateVideoIn();
			
		});

		this.scrollMagicScene.on('leave', (e) => {

			if( document.body.classList.contains('scroll-down') ) {
				this.domElem.classList.remove('active');
			}

			//this.domElem.classList.remove('active');

			if( this.animatedOut === false ) {
				this.animatedOut = true;
			}

			//this.animateVideoOut();
			
		});
	}

	defaultTween() {

		return this.timeline
		/** /
		.fromTo(
			this.domElem.querySelector('.video-holder'), 
			{
				//maxWidth: '100%',
				//borderRadius: '0'
				maxWidth: '90%',
				borderRadius: '30px',
			},
			{
				maxWidth: '90%',
				borderRadius: '30px',
				overwrite: false
			}
		)
		/**/
		.fromTo(
			this.domElem.querySelector('.custom-call-to-action'), 
			{
				webkitFilter: 'blur(20px)',
				autoAlpha: 0,
				scale: 1.2,
			},
			{
				webkitFilter: 'blur(0px)',
				autoAlpha: 1,
				scale: 1,
				overwrite: false
			}
		)
	}

}
